import React from 'react';
function SiteFooter() {
  const handleNewsletter = event => {
    event.preventDefault();
    const email = event.currentTarget.querySelector('input[type="email"]')?.value.trim();
    if (!email) return;
    const subject = encodeURIComponent('Newsletter subscription');
    const body = encodeURIComponent('Please add ' + email + ' to the newsletter mailing list.');
    window.location.href = 'mailto:info@bluevale.edu.in?subject=' + subject + '&body=' + body;
  };
  return (
    <footer id="contact">
      <div className="newsletter">
        <div className="wrap row">
          <div>
            <h4>{"Stay in the loop"}</h4>
            <p>{"Admissions updates, event dates and campus stories — a few times a month."}</p>
          </div>
          <form className="nl-form" onSubmit={handleNewsletter}>
            <input type="email" placeholder="Enter your email" aria-label="Email address" required />
            <button type="submit" aria-label="Subscribe">
              <svg viewBox="0 0 24 24">
                <path d="M2 21l21-9L2 3v7l15 2-15 2v7z"></path>
              </svg>
            </button>
          </form>
        </div>
      </div>
      <div className="wrap">
        <div className="foot-grid">
          <div>
            <div className="foot-brand">
              <img className="footer-logo" src="/image/logo.png" alt="Comprehensive High School" />
              <span className="word">{"Comprehensive High School"}</span>
            </div>
            <p className="foot-desc">{"Empowering students to achieve excellence and make a positive impact on the world — one classroom at a time."}</p>
            <div className="social-row">
              <a href="https://www.facebook.com/csskamoki" aria-label="Facebook" target="_blank" rel="noreferrer">
                <svg viewBox="0 0 24 24" fill="#fff">
                  <path d="M13 22v-9h3l1-4h-4V6.5C13 5.4 13.5 5 14.7 5H17V1.2C16.6 1.1 15.3 1 13.9 1 11 1 9 2.7 9 6.1V9H6v4h3v9h4z"></path>
                </svg>
              </a>
              <a href="https://twitter.com/" aria-label="Twitter" target="_blank" rel="noreferrer">
                <svg viewBox="0 0 24 24" fill="#fff">
                  <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path>
                </svg>
              </a>
              <a href="https://www.youtube.com/playlist?list=PLf-xqIGQ9Gv7UkwWObxS7CXdO-s46Qk66" aria-label="YouTube" target="_blank" rel="noreferrer">
                <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2">
                  <rect x="2" y="5" width="20" height="14" rx="4"></rect>
                  <path d="m10 9 5 3-5 3V9z" fill="#fff" stroke="none"></path>
                </svg>
              </a>
              <a href="https://www.tiktok.com/@comprehensive.hig" aria-label="TikTok" target="_blank" rel="noreferrer">
                <svg viewBox="0 0 24 24" fill="#fff">
                  <path d="M19.6 7.1a5.2 5.2 0 0 1-3.5-1.3v8.1a6.1 6.1 0 1 1-5.3-6v3.4a2.8 2.8 0 1 0 1.9 2.6V2h3.4a5.2 5.2 0 0 0 3.5 3.3v1.8z"></path>
                </svg>
              </a>
            </div>
          </div>
          <div>
            <h5>{"Quick Links"}</h5>
            <ul>
              <li>
                <a href="#top">{"Home"}</a>
              </li>
              <li>
                <a href="#about">{"About Us"}</a>
              </li>
              <li>
                <a href="#academics">{"Academics"}</a>
              </li>
              <li>
                <a href="#campus">{"Campus Life"}</a>
              </li>
            </ul>
          </div>
         
          <div>
            <h5>{"Contact Us"}</h5>
            <ul className="foot-contact">
              <li>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 21s7-6.5 7-12a7 7 0 1 0-14 0c0 5.5 7 12 7 12z"></path>
                  <circle cx="12" cy="9" r="2.5"></circle>
                </svg>
                <span>
                  {"GT. Road. Kamoke,"}
                  <br />
                  {"Near Nazir Hospital"}
                </span>
              </li>
              <li>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6 19.8 19.8 0 0 1-3.1-8.7A2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .3 2 .7 3a2 2 0 0 1-.4 2.1L8 10.3a16 16 0 0 0 6 6l1.5-1.5a2 2 0 0 1 2.1-.4c1 .4 2 .6 3 .7a2 2 0 0 1 1.7 2z"></path>
                </svg>
                <span>{"0321-7403238 / 0320-4680800"}</span>
              </li>
              <li>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M4 4h16v16H4z"></path>
                  <path d="m4 4 8 9 8-9"></path>
                </svg>
                <span>{"chskamoke1@gmail.com"}</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="foot-bottom">
          <span>{"© 2026 Comprehensive High School. All rights reserved."}</span>
          <div className="links">
            <a href="#">{"Privacy Policy"}</a>
            <a href="#">{"Terms & Conditions"}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default SiteFooter;
